import './LandingFAQ.scss';

import { FC } from 'react';
import { Trans } from 'react-i18next';

import FAQs, { FAQsItem } from '../../../../components/FAQs/FAQs';
import FAQsWeb from '../../../../components/FAQs/FAQsWeb';
import LandingSectionTitle from '../LandingSectionTitle/LandingSectionTitle';

const className = 'c-LandingFAQ';
const HardcodedTitle = ({ className }: { className: string }) => (
  <Trans
    i18nKey="landing.faqTitle"
    defaults="Top <regular>eSIM</regular> Questions, Answered"
    components={{
      regular: <span className={`${className}__title`} />,
    }}
  />
);

type Props =
  | {
      type?: 'hardcoded';
    }
  | {
      type?: 'content-based';
      Title: JSX.Element | null;
      faqs: FAQsItem[];
    };

const LandingFAQ: FC<Props> = (props = { type: 'hardcoded' }) => {
  const isContentBased = props.type === 'content-based';

  return (
    <div className={className}>
      <LandingSectionTitle textAlign="center">
        {isContentBased ? (
          <>{props.Title}</>
        ) : (
          <HardcodedTitle className={className} />
        )}
      </LandingSectionTitle>
      <div className={`${className}__faqs_container`}>
        {isContentBased ? <FAQs faqsItems={props.faqs} /> : <FAQsWeb />}
      </div>
    </div>
  );
};

export default LandingFAQ;
